module.exports = {"professional":{"label":"Current job situation","fulltime_regular":"Full-time on a regular basis","fulltime_temp":"Temporary full-time","partialtime_regular":"Part-time on a regular basis","partialtime_temp":"Temporary part-time","unemployed":"Unemployed","nonapplicable":"Non applicable"}}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/professionallevels.json
// module id = qHYM
// module chunks = 19